const { size } = require('../size')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {array|object} fields
 * @param {array} requiredFields
 * @returns {boolean}
 */
function missingRequiredField (fields = [], requiredFields = []) {
  if (!size(requiredFields)) return false
  if (!size(fields) && size(requiredFields)) return true

  for (const field of requiredFields) {
    if (!fields?.includes(field)) return true
  }

  return false
}

module.exports = { missingRequiredField }
